import { getItemGroup, isRxMainItem } from './rx'

export const isNotRxOrRxMainItem = (item: any) =>
  !getItemGroup(item) || isRxMainItem(item)

export const isPrescriptionLensType = (referenceKey: string | undefined) =>
  !!referenceKey && referenceKey !== 'type_none'
